import React from 'react';
import { AlertTriangle, Scale, Compass } from 'lucide-react';
export function ProblemValue() {
  const problems = [{
    icon: AlertTriangle,
    title: 'Scattered Reviews',
    desc: 'Scores are fragmented across dozens of sites. Who do you trust when IGN says 9 and a YouTuber says 4?',
    color: 'text-pinnacle-orange'
  }, {
    icon: Scale,
    title: 'Biased Ratings',
    desc: "Individual outlets have editorial biases. A single opinion shouldn't determine a game's fate.",
    color: 'text-pinnacle-red'
  }, {
    icon: Compass,
    title: 'Discovery Overload',
    desc: 'With 12,000+ games released yearly, finding the hidden gems in the noise is nearly impossible.',
    color: 'text-pinnacle-cyan'
  }];
  return <section className="py-24 bg-pinnacle-dark relative overflow-hidden" data-id="element-126">
      <div className="container mx-auto px-4" data-id="element-127">
        <div className="text-center mb-16" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-129">
            The Game Review Chaos
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-130">
            Gamers waste hours reading conflicting reviews and watching video
            essays just to decide on a purchase.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-131">
          {problems.map((item, idx) => <div key={idx} className="bg-pinnacle-card border border-pinnacle-border p-8 rounded-2xl hover:border-gray-600 transition-colors group" data-id="element-132">
              <div className={`w-14 h-14 rounded-xl bg-pinnacle-dark flex items-center justify-center mb-6 border border-pinnacle-border group-hover:scale-110 transition-transform duration-300`} data-id="element-133">
                <item.icon className={`w-7 h-7 ${item.color}`} data-id="element-134" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-135">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-136">{item.desc}</p>
            </div>)}
        </div>

        <div className="mt-24 bg-gradient-to-r from-pinnacle-card to-pinnacle-dark border border-pinnacle-border rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-12" data-id="element-137">
          <div className="flex-1" data-id="element-138">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-139">
              The Pinnacle Solution
            </h3>
            <ul className="space-y-4" data-id="element-140">
              {[{
              title: 'Unified Scores',
              desc: 'We aggregate critic and user scores into one trusted rating.'
            }, {
              title: 'Curated Top Lists',
              desc: 'Expert-curated lists updated weekly across every genre.'
            }, {
              title: 'Real-Time Tracking',
              desc: 'Scores update dynamically as new reviews come in.'
            }].map((val, i) => <li key={i} className="flex items-start gap-4" data-id="element-141">
                  <div className="w-6 h-6 rounded-full bg-pinnacle-green/20 flex items-center justify-center mt-1 flex-shrink-0" data-id="element-142">
                    <div className="w-2 h-2 rounded-full bg-pinnacle-green" data-id="element-143"></div>
                  </div>
                  <div data-id="element-144">
                    <strong className="text-white block" data-id="element-145">{val.title}</strong>
                    <span className="text-gray-400 text-sm" data-id="element-146">{val.desc}</span>
                  </div>
                </li>)}
            </ul>
          </div>
          <div className="flex-1 relative" data-id="element-147">
            {/* Abstract visual representation of aggregation */}
            <div className="relative w-full aspect-video bg-pinnacle-dark rounded-xl border border-pinnacle-border overflow-hidden flex items-center justify-center" data-id="element-148">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-pinnacle-green/10 to-transparent" data-id="element-149"></div>
              <div className="text-center z-10" data-id="element-150">
                <div className="text-6xl font-bold text-white mb-2 font-display" data-id="element-151">
                  94
                </div>
                <div className="text-pinnacle-green uppercase tracking-widest text-sm font-bold" data-id="element-152">
                  Pinnacle Score
                </div>
              </div>

              {/* Orbiting particles */}
              {[...Array(8)].map((_, i) => <div key={i} className="absolute w-2 h-2 bg-gray-600 rounded-full" style={{
              top: '50%',
              left: '50%',
              transform: `rotate(${i * 45}deg) translate(${100 + Math.random() * 20}px) rotate(-${i * 45}deg)`,
              opacity: 0.5
            }} data-id="element-153" />)}
              <div className="absolute w-40 h-40 border border-pinnacle-green/20 rounded-full animate-pulse" data-id="element-154"></div>
              <div className="absolute w-60 h-60 border border-dashed border-gray-700 rounded-full animate-[spin_10s_linear_infinite]" data-id="element-155"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}